var map = {
	"./account-icon.svg": "./src/assets/navigationdrawer-ax/account-icon.svg",
	"./ax-icon.svg": "./src/assets/navigationdrawer-ax/ax-icon.svg",
	"./close-icon.svg": "./src/assets/navigationdrawer-ax/close-icon.svg",
	"./closebtn-icon.svg": "./src/assets/navigationdrawer-ax/closebtn-icon.svg",
	"./config-account-icon.svg": "./src/assets/navigationdrawer-ax/config-account-icon.svg",
	"./document-icon.svg": "./src/assets/navigationdrawer-ax/document-icon.svg",
	"./download-icon.svg": "./src/assets/navigationdrawer-ax/download-icon.svg",
	"./folios-icon.svg": "./src/assets/navigationdrawer-ax/folios-icon.svg",
	"./help-icon.svg": "./src/assets/navigationdrawer-ax/help-icon.svg",
	"./home-icon.svg": "./src/assets/navigationdrawer-ax/home-icon.svg",
	"./metrics-icon.svg": "./src/assets/navigationdrawer-ax/metrics-icon.svg",
	"./open-icon.svg": "./src/assets/navigationdrawer-ax/open-icon.svg",
	"./pos-icon.svg": "./src/assets/navigationdrawer-ax/pos-icon.svg",
	"./purchase-icon.svg": "./src/assets/navigationdrawer-ax/purchase-icon.svg",
	"./report-icon.svg": "./src/assets/navigationdrawer-ax/report-icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/navigationdrawer-ax sync recursive ^\\.\\/.*\\-icon\\.svg$";